import $ from 'jquery';

export default {
  properties: {
    editTodoUrl: {
      type: String,
    },
  },

  ready() {
    this.listenTo(this, 'tr-todo-assignee-select-field:change', this.handleAssigneeChanged.bind(this));
    this.listenTo(this, 'tr-todo-date-field:change', this.handleDateChange.bind(this));
  },

  parseDate(dates) {
    let startAt;
    let dueAt;
    if (dates.length === 2) {
      [startAt, dueAt] = dates;
    } else {
      startAt = null;
      [dueAt] = dates;
    }
    return [startAt, dueAt];
  },

  handleDateChange(e) {
    e.stopPropagation();
    if (e.detail.length) {
      const [startAt, dueAt] = this.parseDate(e.detail.split(','));
      this.updateTodo({ start_at: startAt, due_at: dueAt });
    } else {
      this.updateTodo({ start_at: null, due_at: null });
    }
  },

  handleAssigneeChanged(e) {
    e.stopPropagation();
    this.updateTodo({
      assignee_guid: e.detail,
    });
  },

  updateTodo(data, callback) {
    let dataType = 'json';
    if (this.editTodoUrl.indexOf('members') !== -1) {
      dataType = 'script';
    }
    $.ajax({
      url: this.editTodoUrl,
      type: 'patch',
      dataType,
      data: {
        todos_management: data,
      },
      success: callback,
    });
  },
};
